import { useState } from "react";
import useStableCallback from "src/hooks/useCallbackUtils/useStableCallback";
export default function useNoteTabsDraft(note) {
    const [state, setState] = useState(() => {
        const contentMap = new Map();
        note.tabs.forEach((tab) => {
            contentMap.set(tab.id, tab.data.content ?? '');
        });
        return contentMap;
    });
    const setTabContent = useStableCallback((tabID, content) => {
        setState((prev) => {
            const next = new Map(prev);
            next.set(tabID, content);
            return next;
        });
    });
    const deleteTabContent = useStableCallback((tabID) => {
        setState((prev) => {
            const next = new Map(prev);
            next.delete(tabID);
            return next;
        });
    });
    const hasTabChanges = useStableCallback((tab) => {
        const draft = state.get(tab.id);
        return draft !== undefined && draft !== (tab.data.content ?? '');
    });
    const actions = {
        setTabContent,
        deleteTabContent,
    };
    const helpers = {
        getChangedTabs() {
            return note.tabs
                .filter((tab) => hasTabChanges(tab))
                .map((tab) => ({
                tabID: tab.id,
                content: state.get(tab.id) ?? tab.data.content ?? '',
                version: tab.data.version ?? 0,
            }));
        },
    };
    return [state, actions, helpers];
}
